export default [{
        path: "/logistica/informes/monitoreoPesca",
        name: "logistica-reportes",
        component: () =>
            import ("@/views/pages/monitoreoPesca/MonitoreoPesca.vue"),
        meta: {
			title: 'i18n:',
            pageTitle: "Monitoreo de Pesca Entre Plantas",
            breadcrumb: [{
                text: "Monitoreo de Pesca",
                active: true
            }]
        }
    },

    {
        path: "/logistica/mantenimiento/zonas",
        name: "logistica-mantenimiento-zonas",
        component: () =>
            import ("@/views/pages/logistica/mantenimientoZonas.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-mantenimiento-zonas",
            pageTitle: "Mantenimiento de zonas",
            breadcrumb: [{
                text: "Zonas",
                active: true
            }]
        }
    },

    {
        path: "/logistica/mantenimiento/camaroneras",
        name: "logistica-mantenimiento-camaroneras",
        component: () =>
            import ("@/views/pages/logistica/mantenimientoCamaroneras.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-mantenimiento-camaroneras",
            pageTitle: "Mantenimiento de Camaroneras",
            breadcrumb: [{
                text: "Camaroneras",
                active: true
            }]
        }
    },
    {
        path: "/logistica/mantenimiento/sectores",
        name: "logistica-mantenimiento-sectores",
        component: () =>
            import ("@/views/pages/logistica/mantenimientoSectores.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-mantenimiento-sectores",
            pageTitle: "Mantenimiento de Sectores",
            breadcrumb: [{
                text: "sectores",
                active: true
            }]
        }
    },
    {
        path: "/logistica/mantenimiento/piscinas",
        name: "logistica-mantenimiento-piscinas",
        component: () =>
            import ("@/views/pages/logistica/mantenimientoPiscinas.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-mantenimiento-piscinas",
            pageTitle: "Mantenimiento de Piscinas",
            breadcrumb: [{
                text: "Piscinas",
                active: true
            }]
        }
    },
    {
        path: "/logistica/mantenimiento/rutas",
        name: "logistica-mantenimiento-rutas",
        component: () =>
            import ("@/views/pages/logistica/ruta.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-mantenimiento-rutas",
            pageTitle: "Mantenimiento de Rutas",
            breadcrumb: [{
                text: "Rutas",
                active: true
            }]
        }
    },

    {
        path: "/logistica/transacciones/distribucion-pesca",
        name: "logistica-transacciones-distribucion-pesca",
        component: () =>
            import ("@/views/pages/logistica/distribucionPesca.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-transacciones-distribucion-pesca",
            pageTitle: "Distribución de Pescas",
            breadcrumb: [{
                text: "Distribución Pesca",
                active: true
            }]
        }
    },

    {
        path: "/logistica/transacciones/cambio-destino",
        name: "logistica-transacciones-cambio-destino",
        component: () =>
            import ("@/views/pages/logistica/cambioDestino.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-transacciones-cambio-destino",
            pageTitle: "Actualización de Destino",
            breadcrumb: [{
                text: "Cambio Destino",
                active: true
            }]
        }
    },

    {
        path: "/logistica/informes/distribucion-pesca",
        name: "logistica-informes-distribucion-pesca",
        component: () =>
            import ("@/views/pages/logistica/reporteDistribucionPesca.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-informes-distribucion-pesca",
            pageTitle: "Distribución de Pescas",
            breadcrumb: [{
                text: "Distribución Pesca",
                active: true
            }]
        }
    },

    {
        path: "/logistica/mantenimiento/aprob-zona",
        name: "logistica-mantenimiento-aprob-zona",
        component: () =>
            import ("@/views/pages/logistica/mantenimientoAprobZonas.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-mantenimiento-aprob-zona",
            pageTitle: "Aprobación de zonas",
            breadcrumb: [{
                text: "Aprobación de zonas",
                active: true
            }]
        }
    },

    {
        path: "/logistica/transaccion/cambio-camaronera-raleo",
        name: "logistica-transaccion-cambio-camaronera-raleo",
        component: () =>
            import ("@/views/pages/logistica/modificacionCamXRaleo.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-transaccion-cambio-camaronera-raleo",
            pageTitle: "Cambio de camaronera",
            breadcrumb: [{
                text: "Cambio camaronera",
                active: true
            }]
        }
    },

    {
        path: "/logistica/informes/estado-bines",
        name: "logistica-informes-estado-bines",
        component: () =>
            import ("@/views/pages/logistica/estadoBines.vue"),
        meta: {
			title: 'i18n:',
            resource: "Logistica",
            action: "ver-logistica-informes-estado-bines",
            pageTitle: "Estado Bines",
            breadcrumb: [{
                text: "Estado Bines",
                active: true
            }]
        }
    },

];


//ver-logistica-informes-estado-bines
